import "./connectionPage.css";
import { connectionProfileType, connectionType } from "../../types/types";
import { ConnectionType } from "../../components/connectionType/connectionType";
import { useState } from "react";
import { Box, Grid, Button } from "@mui/material";
import { Loader } from "../../components/loader/Loader";
export function ConnectionPage(props: { setConnectionType: Function, increment: () => void, decrement: () => void , profileAttributes : connectionType[], activeProfile : connectionProfileType}) {

  const [clicked, setClicked] = useState<connectionType>(
    props.profileAttributes.find((attr) => attr.providerType === props.activeProfile.attributes.provider) || props.profileAttributes[0]
  );

  const handleClick = (profile: connectionType) => {
    setClicked(profile);
  };

  return (
    <Box>
      {props.profileAttributes.length === 0 && <Loader></Loader>} 
      {props.profileAttributes.length !== 0 && 
      <Box paddingX={"10%"} paddingY={4}>
        <Grid container columnSpacing={4} rowSpacing={4} className="connectionPage-wrapper">
          {
            props.profileAttributes.map((profile) => (
                <Grid key={profile.name} item lg={3} md={4} sm xs>
                  <ConnectionType
                    key={profile.name}
                    providerType={profile.providerType}
                    image={profile.image}
                    name={profile.name}
                  active={clicked === profile}
                    onClick={() => {
                      handleClick(profile);
                    }}
                  />
                </Grid>
            ))}
        </Grid>
        <Box width={"100%"} display="flex">
          <Button className="navigation-btn bottom-bar-navigation-btn" onClick={props.decrement} variant="contained">Previous</Button>
          <Button className="navigation-btn bottom-bar-navigation-btn" onClick={()=>{props.setConnectionType(clicked); props.increment()}} variant="contained">Next</Button>
        </Box>
      </Box>}
    </Box>
  );
}
